import {
  cacheClient,
  lpProcessorClient,
  processorClient,
  reportingClient,
} from '../graphql/client';

export const clients = {
  processor: processorClient,
  statechainCache: cacheClient,
  lpProcessor: lpProcessorClient,
  reportingService: reportingClient,
} as const;
export type Client = keyof typeof clients;
